var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.module.progress.maximum > 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('module-progress',{staticClass:"progress-steps",attrs:{"progress":_vm.module.progress}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }